module.exports = __webpack_public_path__ + "img/word.c6e2c992.svg";